export const ID_COLUMN_WIDTH = 100
export const SUPPLY_NUMBER_COLUMN_WIDTH = 100
export const SUPPLY_COLUMN_WIDTH = 100
export const DATE_COLUMN_WIDTH = 100
export const CURRENT_TOTAL_COLUMN_WIDTH = 100
export const ADDRESS_COLUMN_WIDTH = 100
export const QUANTITY_COLUMN_WIDTH = 100
export const INVOICE_COLUMN_WIDTH = 100
